import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import type { I18nKey } from "../i18n";
import { Tooltip, TooltipPopup, TooltipTrigger } from "./ui/tooltip";

export function PolicyControlTooltip({
  reason,
  children,
  className = "inline-flex",
}: {
  reason: I18nKey | null;
  children: ReactNode;
  className?: string;
}) {
  const { t } = useTranslation();
  if (reason === null) return children;
  const description = t(reason);
  return (
    <Tooltip>
      <TooltipTrigger render={<span className={className} tabIndex={0} aria-label={description} />}>
        {children}
      </TooltipTrigger>
      <TooltipPopup side="top">{description}</TooltipPopup>
    </Tooltip>
  );
}
